import { getInitialState } from "./state.js";
import { ActionTypes } from "./actions.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.fetch:
            return {
                ...state,
                fetchStatus: "loading"
            };
        case ActionTypes.fetchSuccess:
            return {
                ...state,
                fetchStatus: "success",
                aggregations: action.payload.aggregations,
                results: action.payload.results,
                initialPayload: action.payload.initialPayload,
                fromCity: action.payload.fromCity ?? state?.fromCity,
                destination: action.payload.destination
            };
        case ActionTypes.fetchError:
            return {
                ...state,
                fetchStatus: "failed",
                error: action.payload.error
            };
        case ActionTypes.reset:
            return {
                ...initialState,
                ...(state?.countries ? { countries: state.countries } : {})
            };
        default:
            return state;
    }
};
export { reducer, getInitialState };
